'use strict';

import summernoteConfig from '../summernote.config';

export default class NanoreaderAddController {

    /*@ngInject*/
    constructor($http, $state, Upload, toaster) {
        this.$http = $http;
        this.$state = $state;
        this.Upload = Upload;
        this.toaster = toaster;
        this.summernoteConfig = summernoteConfig;
        this.newFirmware = {
            betaGroups: [],
            buildType: 'user',
            fwType: 'nanoreader',
            lang: ['zh_CN']
        };
    }

    $onInit() {
        this.getBetaGroups();
    }

    getBetaGroups() {
        this.$http.get('/api/betaGroups').then(res => {
            this.betaGroups = res.data;
        });
    }

    uploadFirmwareFile(file) {
        if (!file) {
            return;
        }
        this.toaster.pop({
            type: 'wait',
            title: '正在上传固件，请稍等...',
            body: file.name,
            timeout: 3000 * 1000
        });

        file.upload = this.Upload.upload({
            url: '/api/firmware/uploadFirmwareFile',
            file: file,
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });

        file.upload.progress((evt) => {
            file.progress = Math.min(100, parseInt(100.0 * evt.loaded / evt.total));
        });

        file.upload.success((data, status, headers, config) => {
            this.toaster.clear();
            this.newFirmware.downloadUrlList = [data.url];
            this.newFirmware.md5 = data.md5;
            this.newFirmware.size = data.size;
            this.firmwareUrl = data.url;
            this.toaster.pop('success', '上传成功', file.name);
        });

        file.upload.error((err) => {
            this.toaster.clear();
            this.toaster.pop('error', '上传失败', JSON.stringify(err));
        });
    }

    toggleSelection(id) {
        let idx = this.newFirmware.betaGroups.indexOf(id);
        if (idx > -1) {
            this.newFirmware.betaGroups.splice(idx, 1);
        } else {
            this.newFirmware.betaGroups.push(id);
        }
    }

    genFingerprint() {
        return `Onyx/${this.newFirmware.model}/${this.newFirmware.buildNumber}:${this.newFirmware.buildType}`;
    }

    checkStr(str) {
        if (str && typeof str == 'string') {
            str = str.trim();
        }
        return str;
    }

    checkData() {
        if (this.checkStr(this.newFirmware.model)
            && this.newFirmware.buildNumber
            && this.checkStr(this.newFirmware.buildType)
            && this.newFirmware.lang && this.newFirmware.lang.length
            && this.checkStr(this.newFirmware.changeListHtml)
            && this.newFirmware.md5
            && this.newFirmware.size
            && this.newFirmware.downloadUrlList && this.newFirmware.downloadUrlList.length) {
            return true;
        }
        this.toaster.pop({
            type: 'error',
            title: '请填写必填项并上传固件文件',
            timeout: 3 * 1000
        });
        return false;
    }

    save() {
        if (this.newFirmware.changeListHtml) {
            let text = this.newFirmware.changeListHtml.replace(/<br\s*\/?>/gi, '\n').replace(/<\/p>/gi, '\n').replace(/<[^>]+>/g, '');
            this.newFirmware.changeList = text.split('\n').filter(line => line.trim().length > 0);
        }
        if (!this.checkData()) {
            return;
        }
        this.newFirmware.brand = 'Onyx';
        this.newFirmware.fingerprint = this.genFingerprint();
        this.newFirmware.fwType = 'nanoreader';
        if (this.newFirmware.buildDisplayId) {
            this.newFirmware.buildDisplayId = this.newFirmware.buildDisplayId.trim();
        }
        this.$http.post(`/api/firmware`, this.newFirmware).then(res => {
            this.$state.go('^');
        }).catch(err => {
            this.toaster.pop('error', '保存失败', (err && err.data && err.data.msg) || '请稍后重试');
        });
    }
}



// WEBPACK FOOTER //
// ./client/app/firmwares/nanoreader/nanoreader.controller.js